const ORIGIN = typeof window !== "undefined" ? window.location.origin : "";

// Empuja los sitelinks de Google: declara la navegación principal del sitio.
export const navigationSchema = () => ({
  "@context": "https://schema.org",
  "@type": "ItemList",
  itemListElement: [
    { "@type": "SiteNavigationElement", position: 1, name: "Roteiro Personalizado", url: `${ORIGIN}/viaje-a-medida` },
    { "@type": "SiteNavigationElement", position: 2, name: "Viagens em Grupo para Mulheres", url: `${ORIGIN}/viajes-en-grupo` },
    { "@type": "SiteNavigationElement", position: 3, name: "Concierge para Casamentos", url: `${ORIGIN}/concierge-casamentos` },
    { "@type": "SiteNavigationElement", position: 4, name: "Lua de Mel sob Medida", url: `${ORIGIN}/lua-de-mel` },
    { "@type": "SiteNavigationElement", position: 5, name: "Brasil sob Medida", url: `${ORIGIN}/brasil` },
    { "@type": "SiteNavigationElement", position: 6, name: "Quiz de Destinos", url: `${ORIGIN}/quiz` },
    { "@type": "SiteNavigationElement", position: 7, name: "Blog", url: `${ORIGIN}/recursos/blog` },
  ],
});

export const websiteSchema = () => ({
  "@context": "https://schema.org",
  "@type": "WebSite",
  name: "WYD personal travelling",
  alternateName: ["WYD · What's your desire?", "WYD travel", "WYD viagens", "WYD viagens sob medida"],
  url: ORIGIN,
  inLanguage: ["pt-BR", "es", "en", "it"],
});

export const agencySchema = (settings) => ({
  "@context": "https://schema.org",
  "@type": "TravelAgency",
  name: "WYD personal travelling",
  alternateName: ["WYD · What's your desire?", "WYD travel", "WYD viagens", "WYD viagens sob medida"],
  url: ORIGIN,
  logo: `${ORIGIN}/brand/logo-horizontal.png`,
  image: `${ORIGIN}/brand/logo-horizontal.png`,
  description:
    "Agência boutique de viagens sob medida e viagens em grupo para mulheres. Consultoria completa: desenho de roteiro, reservas gerenciadas e concierge em tempo real.",
  telephone: settings?.phone || "+39 351 470 7429",
  email: settings?.email || "hola@wydtravel.com",
  sameAs: [settings?.instagram, settings?.instagram_it].filter(Boolean),
  identifier: { "@type": "PropertyValue", propertyID: "Cadastur", value: "68.715.343/0001-76" },
  founder: [
    { "@type": "Person", name: "Clarissa Pereira", jobTitle: "Co-founder" },
    { "@type": "Person", name: "Luis Araújo", jobTitle: "Co-founder" },
  ],
  areaServed: ["BR", "IT", "US", "ES", "PT"],
  availableLanguage: ["Portuguese", "Spanish", "English", "Italian"],
  knowsAbout: [
    "Tailor-made travel planning",
    "Travel consultancy",
    "Brazil itineraries",
    "Women-only group trips",
    "Travel concierge",
  ],
});

export const faqSchema = (items) => ({
  "@context": "https://schema.org",
  "@type": "FAQPage",
  mainEntity: (items || []).map((i) => ({
    "@type": "Question",
    name: i.q,
    acceptedAnswer: { "@type": "Answer", text: i.a },
  })),
});

const planService = (name, description, price) => ({
  "@context": "https://schema.org",
  "@type": "Service",
  name,
  description,
  serviceType: "Travel design and consultancy",
  provider: { "@type": "TravelAgency", name: "WYD personal travelling", url: ORIGIN },
  areaServed: ["BR", "IT", "US", "ES", "PT"],
  offers: { "@type": "Offer", price, priceCurrency: "BRL", url: `${ORIGIN}/viaje-a-medida` },
});

export const planServiceSchemas = () => [
  planService(
    "Design de Viagem",
    "Diagnóstico por videochamada, roteiro dia a dia com noites por cidade, opções de hotéis e orçamento estimado.",
    "1400"
  ),
  planService(
    "Design + Reservas",
    "Tudo do plano Design mais orçamento fechado, cronograma de pagamentos e todas as reservas feitas pela WYD.",
    "2600"
  ),
  planService(
    "Concierge de Viagem",
    "Tudo reservado mais suporte em tempo real durante a viagem: voos, transfers e imprevistos resolvidos pela WYD.",
    "4000"
  ),
];

export const tripsListSchema = (deps) => ({
  "@context": "https://schema.org",
  "@type": "ItemList",
  name: "WYD group trips for women",
  itemListElement: (deps || []).map((d, i) => ({
    "@type": "ListItem",
    position: i + 1,
    name: d.destination_name,
    url: `${ORIGIN}/salida/${d.slug || d.destination_id || d.id}`,
  })),
});

export const tripSchema = (dep) => ({
  "@context": "https://schema.org",
  "@type": "TouristTrip",
  name: dep.destination_name,
  description: (dep.includes || []).slice(0, 4).join(". ") || dep.destination_name,
  touristType: "Women-only boutique group trip",
  provider: { "@type": "TravelAgency", name: "WYD personal travelling", url: ORIGIN },
  itinerary: dep.itinerary?.length
    ? {
        "@type": "ItemList",
        itemListElement: dep.itinerary.map((d, i) => ({
          "@type": "ListItem",
          position: i + 1,
          name: d.title,
          description: d.description,
        })),
      }
    : undefined,
  offers: dep.price
    ? {
        "@type": "Offer",
        price: dep.price.replace(/[^\d.,]/g, "").replace(".", "").replace(",", ".") || undefined,
        priceCurrency: dep.price.includes("€") ? "EUR" : dep.price.includes("R$") ? "BRL" : "USD",
      }
    : undefined,
});

export const brazilDestinationSchema = () => ({
  "@context": "https://schema.org",
  "@type": "TouristDestination",
  name: "Brasil",
  description:
    "Viagens sob medida pelo Brasil com a WYD: Rio de Janeiro, Fernando de Noronha, Lençóis Maranhenses, Gramado e Salvador, com concierge 24/7 em PT, ES, EN e IT.",
  url: `${ORIGIN}/brasil`,
  includesAttraction: [
    "Rio de Janeiro",
    "Fernando de Noronha",
    "Lençóis Maranhenses",
    "Gramado e Serra Gaúcha",
    "Salvador e Bahia",
  ].map((name) => ({ "@type": "TouristAttraction", name })),
});
